import App from "../../../vendor_core/core/src/App";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import { Tween } from "../../../vendor_core/core/src/Tween";
import ConsoleUtil from "../../../vendor_core/core/src/utils/ConsoleUtil";
import GameLoader from "../../../vendor_core/core/src/utils/GameLoader";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorPreloadState from "../../../vendor_core/src/states/VendorPreloadState";
import BackgroundHelpers from "../view/background/CRCBackgroundHelper";
import GameSoundVars from "../enums/GameSoundVars";
import LocalData from "../../../vendor_core/core/src/utils/LocalData";
import LocalStorageVars from "../../../vendor_core/core/src/const/LocalStorageVars";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import ConfigManager from "../../../vendor_core/core/src/managers/ConfigManager";
import { ConfigurationTypes } from "../../../vendor_core/core/src/const/ConfigurationTypes";
import IDoubleChanceConfig from "../server/interface/IDoubleChanceConfig";
import { Container } from "pixi.js";
import LogoHelper from "../view/logo/LogoHelper";
import CoinModel from '../../model/CoinModel';
import { getScatterBoostCost } from '../ui/commands/CRGameCommands';

export default class CRCPreloaderState extends VendorPreloadState {
    protected setupReels(): void {

        const reelGroup = InstanceFactory.getClass("ReelGroup", true) as ReelGroup;

        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .addSubView(reelGroup, "ReelGroup", "reels");

        reelGroup.create(
            ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene(),
            null,
            {
                winLineLayer: "Paylines",
                celеbrationLayer: "PaylineCelebration",
                winSymbolsLayer: "ReelsWin",
            }
        );

        const clientMatrix = [
            [1, 1, 9, 7, 7],
            [6, 11, 2, 10, 5],
            [3, 9, 5, 5, 4],
            [3, 5, 1, 1, 11],
            [6, 10, 3, 7, 7],
            [6, 3, 3, 8, 7]
        ];

        const overlay = [
            {
                id: 4,
                text: "x10"
            },
            {
                id: 3,
                text: "5.0"
            },
        ]

        reelGroup.reels.forEach((reel, ri) => {
            reel.symbols.forEach((symbol, si) => {
                // console.log(ri);
                const id = clientMatrix[ri][si];

                symbol.setId(id);
                if (id === 10) {
                    const overlayData = overlay.pop();
                    symbol.showTextOverlay(overlayData.id, overlayData.text)
                }
                symbol.playAnimation();
            });
        });

        reelGroup.sortSymbols();
    }

    startGame(): void {
        // BackgroundHelpers.backgroundOpen()
        //     .then(() => {
        //         BackgroundHelpers.backgroundLoop();
        //     });
        super.startGame();
        this.initReelFrameAnim();
        VendorModel.allowSwipeSpin = false;
        ReelGroup.instance.disableSwipeSpin();
        CoinModel.changeState();
        const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        const btnValue = betBarSceen.sceneMoneyFields.get("dc_bet_amount");

        const cost = getScatterBoostCost();

        btnValue.value = cost;

    }


    protected initSoundLoading(): void {

        SoundController.musicVolume = App.config.maxMusicVolume || 1;

        GameLoader.loadSoundAssets(GameLoader.config.sounds, () => {
            ConsoleUtil.log("Sound resources loaded");

            SoundController.setSpecificMusicVolume(GameSoundVars.IDLE_MUSIC, 0);
            SoundController.loadSounds(GameLoader.config.sounds);
            SoundController.playSound(GameSoundVars.GAME_START);
            SoundController.playMusic(GameSoundVars.IDLE_MUSIC);

            const storeMusicEnableValue = LocalData.getValue(LocalStorageVars.MUSIC_ENABLED);

            if(storeMusicEnableValue != null && storeMusicEnableValue != "true") {
                SoundController.toggleSound();
            }

        });

    }

    protected onLoginReceived(data) {

        if (data && ConfigManager.hasConfig(ConfigurationTypes.GAME_SPECIFIC)) {
            const dcConfig = ConfigManager.getConfig(ConfigurationTypes.GAME_SPECIFIC);
            (dcConfig as IDoubleChanceConfig).parseConfig(data);
        }

        super.onLoginReceived(data);
        CoinModel.update(data);
    }

    public preloadComplete() {
        LogoHelper.init();

        super.preloadComplete();
    }

    public initReelFrameAnim(): void {
        const scene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const anim = scene.spineAnimations.get("frame_anticipation");
        anim.play("idle");
    }
}
